import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Factory, MessageCircleQuestion, CheckCircle2 } from "lucide-react";
import { API_URL } from "../config";

/**
 * Список производителей оборудования. Раздел построен как поддержка
 * (вопрос-ответ), а не рекламная площадка — см. докстринг Manufacturer
 * в backend/manufacturer_models.py про ч. 8 ст. 24 ФЗ-38 «О рекламе».
 */
export default function Manufacturers() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/manufacturers`)
      .then(r => r.ok ? r.json() : [])
      .then(setItems)
      .catch(() => setItems([]));
  }, []);

  if (items === null) return <section><p style={{ color: "#888" }}>Загрузка…</p></section>;

  return (
    <section style={{ maxWidth: 880 }}>
      <h1 className="section-title" style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Factory size={20} strokeWidth={2.2} color="#e5005b" /> Производители оборудования
      </h1>
      <p style={{ color: "#4a4a68", marginTop: -8, marginBottom: 24, fontSize: "1.02rem", lineHeight: 1.6, maxWidth: 680 }}>
        Технические вопросы по приборам — напрямую производителю. Врач задаёт вопрос,
        представитель компании отвечает публично под своим именем: ответ остаётся на портале
        и помогает всем, кто столкнётся с тем же.
      </p>

      {items.length === 0 ? (
        <p style={{ color: "#888" }}>Производители пока не подключены.</p>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 16 }}>
          {items.map(m => (
            <Link key={m.slug} to={`/manufacturers/${m.slug}`} className="card"
              style={{ textDecoration: "none", color: "inherit", display: "block" }}>
              <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                {m.logo_url ? (
                  <img src={m.logo_url} alt="" style={{ width: 48, height: 48, borderRadius: 8, objectFit: "contain", flexShrink: 0, background: "#fff" }} />
                ) : (
                  <div style={{
                    width: 48, height: 48, borderRadius: 8, background: "#eef0f8", color: "#007c84",
                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                  }}>
                    <Factory size={22} strokeWidth={2} />
                  </div>
                )}
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 700, color: "#1f2937", fontSize: "1rem" }}>{m.name}</div>
                  {m.description && (
                    <div style={{ color: "#666", fontSize: "0.84rem", marginTop: 2, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                      {m.description}
                    </div>
                  )}
                </div>
              </div>
              <div style={{ display: "flex", gap: 14, marginTop: 12, paddingTop: 10, borderTop: "1px solid #eef0f6" }}>
                <span style={{ display: "flex", alignItems: "center", gap: 4, fontSize: "0.82rem", color: "#888" }}>
                  <MessageCircleQuestion size={13} strokeWidth={2.2} /> {m.questions_count} вопросов
                </span>
                {m.answered_count > 0 && (
                  <span style={{ display: "flex", alignItems: "center", gap: 4, fontSize: "0.82rem", color: "#15803d" }}>
                    <CheckCircle2 size={13} strokeWidth={2.2} /> {m.answered_count} с ответом
                  </span>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
